import Card from "../Card";
import SmallHeadingComponent from "../SmallHeadingComponent";

function DummySFQDetailCard() {
    return (
        <Card fill={true}>
            <div className="flex flex-col items-center justify-center h-full p-8">
                <SmallHeadingComponent>Fragebogen-Detail</SmallHeadingComponent>
                <div className="text-lg text-gray-600 mt-4 text-center">
                    Bitte klicken Sie auf einen Datenpunkt im Graphen, um die Details eines speziellen Fragebogens anzuzeigen.
                </div>
            </div>
        </Card>
    );
}

export default DummySFQDetailCard; 